import * as EXTRAROOMS from '../constants/extra-rooms';

export const checkExtraRoomRequest = (payload) => ({
  type: EXTRAROOMS.CHECK_EXTRA_ROOM_REQUEST,
  payload,
});

export const getPackagesForRoomUpgradedAction = (payload) => ({
  type: EXTRAROOMS.GET_PACKAGES_FOR_ROOM_UPGRADE,
  payload,
});

export const getPackagesForRoomUpgradedSuccessAction = (payload) => ({
  type: EXTRAROOMS.GET_PACKAGES_FOR_ROOM_UPGRADE_SUCCESS,
  payload,
});

export const getPackagesForRoomUpgradedFailAction = (payload) => ({
  type: EXTRAROOMS.GET_PACKAGES_FOR_ROOM_UPGRADE_FAIL,
  payload,
});
